import { render, staticRenderFns } from "./ErrorModal.vue?vue&type=template&id=0ecef0f7&scoped=true&"
import script from "./ErrorModal.vue?vue&type=script&lang=js&"
export * from "./ErrorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecef0f7",
  null
  
)

export default component.exports